<template>
  <div id="receive-mail-detail">
    <div class="pt-10 mb-4 mr-6">
      <div id="action-button-detail-trash" class="flex flex-wrap items-end justify-end">
        <vs-button color="#d9d9d9" icon="cancel" @click="onBack">閉じる</vs-button>
      </div>
    </div>

    <vs-row class="mt-6">
      <vs-col>
        <vx-input-group class ="square" type="file">
          <template slot="prepend">
            <div class="prepend-text label-style">
              <span>From</span>
            </div>
          </template>

          <vs-input :readonly="isFormInValid" :class="isFormInValid?'disabled-input':''" v-model="trash_mail.email_sender_full" placeholder="email_sender_full" />
        </vx-input-group>
      </vs-col>
      <vs-col>
        <vx-input-group>
          <template slot="prepend">
            <div class="prepend-text label-style">
              <span>To</span>
            </div>
          </template>

          <vs-input :readonly="isFormInValid" :class="isFormInValid?'disabled-input':''" v-model="trash_mail.to" placeholder="" />
        </vx-input-group> 
      </vs-col>
      <vs-col>
        <vx-input-group>
          <template slot="prepend">
            <div class="prepend-text label-style">
              <span>CC</span>
            </div>
          </template>

          <vs-input :readonly="isFormInValid" :class="isFormInValid?'disabled-input':''" v-model="trash_mail.cc" />
        </vx-input-group> 
      </vs-col>
      <vs-col class="mt-5" v-if="trash_mail.error_detail">
        <div class="prepend-text label-style w-full" style="padding:10px">
          <span class="mr-5"><img src="@/assets/images/other-icons/error.png" style="position: relative;top: 3px;"/></span>
          <span>エラー内容</span>
        </div>
        <vx-card
          class="card-body-mail"
          no-radius
          cardBorder
          :class="isFormInValid ? 'disabled-input' : ''"
        >
          <div
            class="w-full"
            v-html="trash_mail.error_detail"
            style="height: 150px; overflow-y: scroll"
          ></div>
        </vx-card>
      </vs-col>
      <vs-col class="mt-5" style="border: solid 1px #E2E2E2">
        <vx-input-group>
          <template slot="prepend">
            <div class="prepend-text label-style" style="width: 120px;">
              <span>添付ファイル</span>
            </div>
          </template>
          <vs-row>
            <vs-col style="width: max-content; padding: 3px 5px;" :key="index" v-for="(value, index) in trash_mail.attachmentFileName">
              <div @click="downloadAttachment(value.path)">
                <vs-chip style="cursor: pointer;" class="mt-1" color="dark" transparent>{{ value.file_name | convertFileNameReceive }}</vs-chip>
              </div>
            </vs-col>
          </vs-row>
        </vx-input-group> 
      </vs-col>  
    </vs-row>

    <vs-row class="mt-6">
      <vx-card class="card-body-mail" no-radius cardBorder noShadow title="件名" :class="isFormInValid?'disabled-input':''">
        <div class="w-full" v-html="trash_mail.subject" style="padding: 9.8px"></div>
      </vx-card>    
      
      <vx-card class="card-body-mail" no-radius cardBorder noShadow title="お問い合わせ本文" :class="isFormInValid?'disabled-input':''" >
        <quill-editor disabled v-if="trash_mail.body_type == 0" style="height: 560px;" v-model="trash_mail.body" :options="editorOption"/>
        <vs-textarea v-else :readonly="isFormInValid"  v-model="trash_mail.body" placeholder="..." height="560px"/>
      </vx-card>
    </vs-row>

  </div>
</template>

<script>

import {mapActions} from "vuex";
import "@/assets/scss/vuexy/components/view/receivedMailDetail.scss";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    quillEditor,
  },
  
  data() { 
    return {
      isFormInValid: true,
      trash_mail: [],
      editorOption: {
        modules: {
          toolbar: false
        },
        placeholder: ''
      },
    }
  },
  
  methods: {
    ...mapActions({
      getTrashMailDetail: 'mailTrash/getTrashMailDetail',
      downloadFile: "receiveMail/downloadAttachment",
    }),
    async downloadAttachment(file) {
      let data = {
        "id" : this.trash_mail.id,
        "fileName" : file,
      }
      let result = await this.downloadFile(data);
      if (result) {
          const content = result.file_data;
          let fileName = result.file_name;
          let typeDownload = result.file_type;
          // Decode base64 using atob method
          let data = window.atob(content);
          let bytes = new Array(data.length);
          for (let i = 0; i < data.length; i++) {
              bytes[i] = data.charCodeAt(i);
          }
          data = new Uint8Array(bytes);
          let anchor = document.createElement('a');
          if (anchor.download !== undefined) {
            let blob = new Blob([data], {type: typeDownload});
            var objectURL = window.URL.createObjectURL(blob);

            anchor.href = objectURL;
            anchor.download = fileName;
          }
          if (navigator.msSaveBlob) { // IE 10+
            anchor.addEventListener("click", function (event) {
              let blob = new Blob([data], {
                "type": 'text'
              });
              navigator.msSaveBlob(blob, fileName);
            }, false);
          }

          anchor.click();

          URL.revokeObjectURL(objectURL);
      }
    },
    async onBack() {
      let url = new URL(window.location.href);
      let close = url.searchParams.get("back");
      if (close){
        window.close();
      } else {
          this.$router.push({path:`/trash/${this.$route.params.email}`});
      }
    },
  },
  computed: {},

  async created () {
    /* start loading with many requests */
    this.$store.dispatch('updateLoads', true)

    const data = {
      'email' : this.$route.params.email,
      'inquiry_id' : this.$route.params.inquiry_id
    }
    let dataMailTrash = await this.getTrashMailDetail(data);
    if (dataMailTrash) {
      this.trash_mail = dataMailTrash.trash_mail;
      //check email_sender_full
      if (!this.trash_mail.email_sender_full || this.trash_mail.email_sender_full == "") {
        this.trash_mail.email_sender_full = this.trash_mail.email_sender;
      }
    } else {
        this.trash_mail = '';
    }
    /* stop loads */
      localStorage.setItem('refreshPageTrash', true);
      this.$store.dispatch('updateLoads', false)
  },
  watch: {}
}
</script>
<style lang="scss">
  #action-button-detail-trash {
    .vs-button--text {
      line-height: 20px !important;
    }
  }
</style>
